import { USER_ROLES_API_MGMNT } from '~/constants';
import { MeResponse } from '~/userManagementApi/userAccess.types';

export const getMainRoleUserMgnmtApi = (me: MeResponse) => {
  const roles = me?.user_access.length
    ? me.user_access[0].roles.map((key) => key.name)
    : [];

  const mainRole = roles.find((role) =>
    [
      USER_ROLES_API_MGMNT.agencyAdmin,
      USER_ROLES_API_MGMNT.agencyManager,
      USER_ROLES_API_MGMNT.agencyTeam,
    ].includes(role as USER_ROLES_API_MGMNT),
  );

  return mainRole || null;
};
